import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Box } from '../../atoms/Box';

import { COLORS } from '../../../configs/colors';

export const RoleBox = styled(Box)`
  width: 97%;
  padding: 10px;
  border: 2px solid ${COLORS.CardBorder};
  border-radius: 5px;
  background-color: ${COLORS.CardBackground};
  box-sizing: border-box;
`;

export const ContactGridContainer = styled(Grid)`
  margin-bottom: 10px;
`;
